import React from 'react'
import ProductCard from 'components/ProductCard'
import isDeluxeSampleOptionUtil from 'modules/variant/utils/is-deluxe-sample-option'
import isFreeSampleVariantUtil from 'modules/variant/utils/is-free-sample'

/**
 * @param {ProductVariantCarouselInfoProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductVariantCarouselInfo (props) {
  const {
    productVariant,
    featuredProductVariant,
    colorIconUrl,
    colorOption,
    imageUrl,
    loyaltyTierName,
    isRelatedProduct,
    shouldShowFullSizeConversion = false,
    selectedVariantImage,
    compareAtPrice,
    rawPrice,
    ...rest
  } = props

  const image = (
    imageUrl ??
    selectedVariantImage ??
    productVariant.image_url
  )

  const colorIconUrlToPass = (
    colorIconUrl ??
    productVariant.option_icon_url
  )

  const colorOptionToPass = (
    colorOption ??
    productVariant.option_value
  )

  const hasDeluxeSample = (
    isDeluxeSampleOptionUtil(productVariant.variant_name) ||
    productVariant?.deluxe_sample_variants?.length
  )

  const tierName = (
    loyaltyTierName ??
    productVariant.lyt_tier
  )

  return (
    <ProductCard
      featuredProductVariant={featuredProductVariant}
      productVariant={productVariant}
      id={productVariant.product_id}
      handle={productVariant.handle}
      variantId={productVariant.variant_id}
      image={image}
      name={productVariant.title}
      hasDelivery={false}
      shouldLazyLoad
      colorIconUrl={colorIconUrlToPass}
      colorOption={colorOptionToPass}
      sku={productVariant.sku}
      hasDeluxeSample={hasDeluxeSample}
      hasFreeSample={isFreeSampleVariantUtil(productVariant)}
      priceMin={productVariant.price_min}
      priceMax={productVariant.price_max}
      tierName={tierName}
      isTrending={productVariant.trending}
      isViralOnTikTok={productVariant.viral_on_tik_tok}
      isRelatedProduct={isRelatedProduct}
      shouldShowFullSizeConversion={shouldShowFullSizeConversion}
      isSetWithAllFullSize={productVariant.badges_all_full_size}
      isSetWithFullSizeAndMinis={productVariant.badges_full_size_and_minis}
      isSetWithMinis={productVariant.badges_minis}
      isTopGiftSet={productVariant.badges_top_gift}
      isEquinoxLoves={productVariant.badges_equinox_loves}
      isTopDeal={productVariant?.badges_top_deal}
      isAllures2024TopPicks={productVariant.badges_allures_2024_top_picks}
      isBlackOwned={productVariant.badges_black_owned}
      compareAtPrice={compareAtPrice}
      rawPrice={rawPrice}
      {...rest}
    />
  )
}
